import React from 'react';

const SocialEventsDetails = () => {
    return (
        <>
            <section className="event-detail">
                <div className="auto-container">
                    <div className="content-box">

                        <h2>Enhancing Your Event with Exceptional Social Programs</h2>

                        <p>
                            A key highlight of many events is the social program that runs alongside the main activities. Our team specializes in advising on suitable social events and handles the complete logistics and planning for any agreed-upon program. This may include opening and closing ceremonies, lunches and dinners, receptions, and themed parties, all designed to enhance the overall experience of your event.
                        </p>

                        <p>
                            For participants and their accompanying guests who wish to explore the country before or after the event, we also organize a variety of excursions and tours. These curated experiences ensure that every participant leaves with unforgettable memories, adding an extra dimension of enjoyment to their visit.
                        </p>

                    </div>
                </div>
            </section>
        </>
    );
};

export default SocialEventsDetails;
